/**
 * Agent Routes Configuration
 * Routes are now centralized in config/CentralizedRoutes.js
 * This file imports routes from centralized configuration
 */
import { CENTRALIZED_ROUTE_MAP } from '../config/CentralizedRoutes';
import { Navigate } from 'react-router-dom';
import PlaceholderPage from '../pages/agent/PlaceholderPage';

// Redirect component for root agent path
const RedirectToAgentDashboard = () => <Navigate to="/agent/dashboard" replace />;

const createPlaceholderRoute = (title, description) => () => (
  <PlaceholderPage title={title} description={description} />
);

/**
 * Convert centralized route map to React Router route format for agent
 */
export const agentRoutes = [
  { path: '', element: RedirectToAgentDashboard },
  ...Object.entries(CENTRALIZED_ROUTE_MAP)
    .filter(([routePath]) => routePath.startsWith('/agent'))
    .map(([routePath, Component]) => {
      // Remove '/agent' prefix for React Router nested routes, preserving dynamic segments
      let path = routePath.replace('/agent', '') || 'dashboard';
      // Ensure dynamic routes like :id are preserved
      if (path.startsWith('/')) {
        path = path.substring(1);
      }
      
      // Handle redirects for unified pages with tabs
      if (routePath.includes('/knowledge/') && routePath !== '/agent/knowledge') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/agent/knowledge?tab=${tab}`} replace />
        };
      }
      
      // Handle placeholder routes
      if (routePath.includes('/monitoring') || routePath.includes('/configuration')) {
        const title = routePath.split('/').pop().replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        return {
          path,
          element: createPlaceholderRoute(title, `${title} is under construction.`)
        };
      }
      
      return {
        path,
        element: Component
      };
    })
];

export default agentRoutes;
